import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapCancellationConfirmationStatusOptions = (
  attributes: UCM.CancellationStatusOptionRawType,
): UCM.CancellationStatusOptionType => ({
  value: attributes.id,
  label: attributes.code,
});

const getCancellationConfirmationStatusOptions = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.CancellationStatusOptionRawType>
  >(API.GET.cancellationConfirmationStatusOptions);
  return data.data.map(({ attributes }) =>
    mapCancellationConfirmationStatusOptions(attributes),
  );
};

export const useGetCancellationConfirmationStatusOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CANCELLATION_CONFIRMATION_STATUS_OPTIONS],
    queryFn: getCancellationConfirmationStatusOptions,
    ...config,
  });
};
